import { z, ZodType } from "zod";
import { dateString } from "../../utils";

export const Schema = z.object({
    details: z.string().min(10, "Please enter more information to continue"),
    completeTask: z.boolean(),
    numAffected: z.number(),
    startDate: dateString,
    page: z.string().min(1),
    screenshot: z.string().min(1),
    unit: z.string().min(1),
    createdAt: dateString,
    createdBy: z.string().min(1),
    type: z.enum(['EOS', 'IT'])
});
